module.exports = __webpack_public_path__ + "static/media/img-cover-01.658da9c0.jpg";